<mat-form-field>
  <mat-label>
    {{ props.label }}
  </mat-label>
  <input
    matInput
    [errorStateMatcher]="errorStateMatcher"
    [formControl]="datetimeFormControl"
    [matDatepicker]="datepicker"
    [required]="props.required ?? false"
  />
  <mat-datepicker #datepicker />
  @if (datetimeFormControl.value && !props.required) {
    <button
      matSuffix
      type="button"
      class="date-time-clear-button"
      aria-label="Clear date"
      (click)="clear()"
    >
      ✕
    </button>
  }
  <mat-datepicker-toggle [for]="datepicker" matSuffix />
</mat-form-field>

@if (!props.presentation || props.presentation === 'date-time') {
  <mat-form-field>
    <mat-label>
      {{ props.timepickerOptions?.label }}
    </mat-label>
    <input
      matInput
      [errorStateMatcher]="errorStateMatcher"
      [formControl]="datetimeFormControl"
      [matTimepicker]="timepicker"
      [required]="props.required ?? false"
    />
    <mat-timepicker #timepicker />
    <mat-timepicker-toggle [for]="timepicker" matSuffix />
  </mat-form-field>
}
